export default function routeMerge(){
    this.dsAdd("set","conf/load",true);
    this.dsProcess();
}